import React from 'react';

const Notice = () => (
  <>
    <h1>Notice Screen</h1>
  </>
);

export default Notice;
